
import {firebase_Db} from '../../src/config/firebaseConfig';

const DBName = "products";

const CreateNewProducts = async ({ name, price, category, subCategory, description, imgUrl }) => {
    const ref = firebase_Db.Collection(DBName).doc();
    return await firebase_Db.Collection(DBName).add({
        id: ref.id,
        name: name,
        price: price,
        imgUrl: imgUrl,
        description: description,
        category: category,
        subCategory: subCategory,

  });

}


const UpdateProducts = async ({ name, price, category, subCategory, description, imgUrl, id }) => {
    return await firebase_Db.collection(DBName).doc(id).update({
        name: name,
        price: price,
        category: category,
        subCategory: subCategory,
        description: description,
        imgUrl: imgUrl
    });
}

const deleteAProducts = async (id) => {
    return await firebase_Db.collection(DBName).doc(id).delete();
}

const getProducts = () => {
    return firebase_Db.collection(DBName).orderBy("createdAt", "desc").get();
}




export {CreateNewProducts, UpdateProducts, deleteAProducts, getProducts}